import {useCallback,useEffect,useRef,useState} from 'react';
const kinds=['recipe','ingredient','menu','reconciliation'];
const fromUrl=()=>{const kind=window.location.hash.match(/^#imports\/(recipe|ingredient|menu|reconciliation)$/)?.[1];return kind?{tab:'imports',kind,brand:''}:null;};
export default function useImportNavigation(){
 const [route,setRoute]=useState(()=>fromUrl()||{tab:'operations',kind:'recipe',brand:''});
 const current=useRef(route);current.current=route;
 const go=useCallback(next=>{
  const old=current.current;
  if(next.tab==='imports'||old.tab==='imports'){
   window.history.replaceState({...window.history.state,muraiImportRoute:old},'');
   window.history.pushState({...window.history.state,muraiImportRoute:next},'',next.tab==='imports'?'#imports/'+next.kind:window.location.pathname+window.location.search);
  }
  current.current=next;setRoute(next);
 },[]);
 const setTab=useCallback(value=>{const old=current.current;const tab=typeof value==='function'?value(old.tab):value;if(tab!==old.tab)go({...old,tab});},[go]);
 const openImport=useCallback((kind,brand='')=>{if(kinds.includes(kind))go({tab:'imports',kind,brand});},[go]);
 useEffect(()=>{const pop=()=>{const next=fromUrl()||window.history.state?.muraiImportRoute||{tab:'operations',kind:'recipe',brand:''};current.current=next;setRoute(next);};window.addEventListener('popstate',pop);window.addEventListener('hashchange',pop);return()=>{window.removeEventListener('popstate',pop);window.removeEventListener('hashchange',pop);};},[]);
 return {tab:route.tab,setTab,importKind:route.kind,importBrand:route.brand,openImport};
}
